<template>
  <div class="l-page l-page--conversion-all">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main l-main">
      <div class="l-main-head">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" :additional-classes="['p-breadcrumb--conversion-all']" />
        <!-- /パンくずリスト -->
        <div class="c-select-calendar u-w370" @click="onPeriodClick">
          <div class="c-select-calendar__selected">
            <div class="c-icon c-icon--gray-3 u-wh18">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <use xlink:href="/assets/img/sprite.svg#calendar" />
              </svg>
            </div>
            <div class="c-select-calendar__date">
              {{ formattedFrom }}
            </div>
            <div class="c-select-calendar__date">
              {{ formattedTo }}
            </div>
          </div>
          <div class="c-error c-error--balloon c-error--group-name">
            <div class="c-error__text"></div>
          </div>
        </div>
      </div>
      <div class="l-main-content">
        <div class="p-conversion-all-summary">
          <div class="c-title">
            <div class="c-title__text u-fs34">コンバージョン成果</div>
            <div class="c-date u-w420">
              <ul class="c-date-list">
                <li class="c-date-list__item c-date-list__item--label">表示期間</li>
                <li class="c-date-list__item c-date-list__item--from">{{ formattedFrom }}</li>
                <li class="c-date-list__item c-date-list__item--to">{{ formattedTo }}</li>
              </ul>
            </div>
          </div>
          <!-- metrics -->
          <div class="p-conversion-all-summary__metrics">
            <div class="p-metrics-summary">
              <ul class="p-metrics-summary-list">
                <li class="p-metrics-summary-list__item" :class="isLoding.metrics ? 'is-loading' : ''">
                  <div class="c-loader c-loader--small"></div>
                  <dl class="c-metrics c-metrics--total_cv is-active">
                    <dt class="c-metrics__label">合計CV数</dt>
                    <dd class="c-metrics__value">{{ metrics.total_cv }}</dd>
                    <dd class="c-metrics__state-diff">
                      <p class="c-metrics__state-diff-text">前回期間からの増減</p>
                      <p class="c-metrics__state-diff-value">{{ metrics.total_cv_diff }}</p>
                    </dd>
                  </dl>
                </li>
                <li class="p-metrics-summary-list__item" :class="isLoding.metrics ? 'is-loading' : ''">
                  <div class="c-loader c-loader--small"></div>
                  <dl class="c-metrics c-metrics--unique_cv is-active">
                    <dt class="c-metrics__label">ユニークCV数</dt>
                    <dd class="c-metrics__value">{{ metrics.unique_cv }}</dd>
                    <dd class="c-metrics__state-diff">
                      <p class="c-metrics__state-diff-text">前回期間からの増減</p>
                      <p class="c-metrics__state-diff-value">{{ metrics.unique_cv_diff }}</p>
                    </dd>
                  </dl>
                </li>
                <li class="p-metrics-summary-list__item" :class="isLoding.metrics ? 'is-loading' : ''">
                  <div class="c-loader c-loader--small"></div>
                  <dl class="c-metrics c-metrics--optin_user_cv">
                    <dt class="c-metrics__label">通知許諾ユーザーCV数</dt>
                    <dd class="c-metrics__value">{{ metrics.optin_user_cv }}</dd>
                    <dd class="c-metrics__state-diff">
                      <p class="c-metrics__state-diff-text">前回期間からの増減</p>
                      <p class="c-metrics__state-diff-value">{{ metrics.optin_user_cv_diff }}</p>
                    </dd>
                  </dl>
                </li>
                <li class="p-metrics-summary-list__item" :class="isLoding.metrics ? 'is-loading' : ''">
                  <div class="c-loader c-loader--small"></div>
                  <dl class="c-metrics c-metrics--optout_user_cv">
                    <dt class="c-metrics__label">非通知許諾ユーザーCV数</dt>
                    <dd class="c-metrics__value">{{ metrics.optout_user_cv }}</dd>
                    <dd class="c-metrics__state-diff">
                      <p class="c-metrics__state-diff-text">前回期間からの増減</p>
                      <p class="c-metrics__state-diff-value">{{ metrics.optout_user_cv_diff }}</p>
                    </dd>
                  </dl>
                </li>
              </ul>
            </div>
          </div>
          <!-- /metrics -->
          <div class="p-conversion-all-summary__data" :class="isLoding.graph ? 'is-loading' : ''">
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">計測後にデータが反映されます</div>
            </div>
            <svg class="c-graph-line c-graph-line--summary-conversion">
              <defs>
                <clipPath id="clipPath">
                  <rect
                    x="15"
                    y="0"
                    height="330"
                    width="930"
                  />
                </clipPath>
              </defs>
              <g class="c-graph-line-frame" clip-path="url(#clipPath)">
                <rect
                  class="c-graph-line-frame__rect"
                  x="15"
                  y="0"
                  height="330"
                  width="930"
                />
                <line
                  class="c-graph-line-frame__line"
                  x1="15"
                  x2="945"
                  y1="330"
                  y2="330"
                />
              </g>
              <g class="c-graph-line-bg" clip-path="url(#clipPath)">
                <g class="c-graph-line-bg__x" />
                <g class="c-graph-line-bg__y" />
              </g>
              <g class="c-graph-line-chart" clip-path="url(#clipPath)" />
              <g class="c-graph-line-pointer" clip-path="url(#clipPath)">
                <rect
                  class="c-graph-line-pointer__area"
                  x="15"
                  y="0"
                  height="330"
                  width="930"
                />
              </g>
              <g class="c-graph-line-axis">
                <g class="c-graph-line-axis__x" />
                <g class="c-graph-line-axis__y--left" />
                <g class="c-graph-line-axis__y--right" />
              </g>
              <g class="c-graph-line-label" />
            </svg>
            <div class="c-tooltip c-tooltip--graph-line c-tooltip--summary-conversion">
              <div class="c-tooltip__title">-</div>
              <ul class="c-tooltip-list">
                <li class="c-tooltip-list__item c-tooltip-list__item--total_cv">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--unique_cv">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--optin_user_cv">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--optout_user_cv">-</li>
              </ul>
            </div>
          </div>
          <div class="p-conversion-all-summary__data-table" :class="isLoding.metrics ? 'is-loading' : ''">
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">計測後にデータが反映されます</div>
            </div>
            <div style="margin-bottom: 24px;">
              <table class="c-table c-table--summary-group">
                <thead>
                  <tr>
                    <th class="c-table__cell--center is-sortable">
                      <span class="c-table__text">CV名</span>
                      <sort-switch name="conversion_value" :order="sortTargets.conversion_value" @on-click="onSortButtonClick($event)" />
                    </th>
                    <th class="c-table__cell--center u-w190 is-sortable">
                      <span class="c-table__text">合計CV数</span>
                      <sort-switch name="total_cv" :order="sortTargets.total_cv" @on-click="onSortButtonClick($event)" />
                    </th>
                    <th class="c-table__cell--center u-w190 is-sortable">
                      <span class="c-table__text">ユニークCV数</span>
                      <sort-switch name="unique_cv" :order="sortTargets.unique_cv" @on-click="onSortButtonClick($event)" />
                    </th>
                    <th class="c-table__cell--center u-w190 is-sortable">
                      <span class="c-table__text">通知許諾ユーザーCV数</span>
                      <sort-switch name="optin_user_cv" :order="sortTargets.optin_user_cv" @on-click="onSortButtonClick($event)" />
                    </th>
                    <th class="c-table__cell--center u-w190 is-sortable">
                      <span class="c-table__text">非通知許諾ユーザーCV数</span>
                      <sort-switch name="optout_user_cv" :order="sortTargets.optout_user_cv" @on-click="onSortButtonClick($event)" />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, loopIndex1) in conversions" :key="loopIndex1">
                    <td class="c-table__cell--left c-table__cell--middle is-next" style="padding: 12.5px 10px;">
                      <a :href="getNextUrl(item)" style="position: relative;display: block;width: 100%;">
                        <div class="c-text u-w250 u-text-ellipsis">{{ item.conversion_value }}</div>
                      </a>
                    </td>
                    <td class="c-table__cell--center c-table__cell--middle">{{ item.total_cv }}</td>
                    <td class="c-table__cell--center c-table__cell--middle">{{ item.unique_cv }}</td>
                    <td class="c-table__cell--center c-table__cell--middle">{{ item.optin_user_cv }}</td>
                    <td class="c-table__cell--center c-table__cell--middle">{{ item.optout_user_cv }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <pagination :pagination-info="paginationInfo" @on-page-click="onPageClick($event)" />
            <div v-show="isShowDisplayNumberPerPage" style="position: absolute; bottom: 0; right: 25%;">表示件数
              <select
                v-model="perPage"
                style="border: solid 1px #ccc; position: relative; border-radius: 5px; padding: 0 10px; height: 38px;"
                @change="onPerPageChanged()"
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </main>

    <!-- モーダル: 表示期間の選択 -->
    <calendar-modal
      ref="refCalendarModal"
      :is-active=isActiveCalendarModal
      cancel-button-label="キャンセル"
      enter-button-label="決定"
      :dates="params"
      :on-close-click="onCloseCalendarModal"
      :on-cancel-click="onCancelCalendarModal"
      :on-enter-click="onEnterCalendarModal"
    />
    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal :is-active=isError :message=errorMessage :on-close-click="onCloseErrorModal" />
  </div>
</template>

<script>
import axios from 'axios';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');

export default {
  props: {
    breadcrumbData: Array,
    linkData: Object,
    displayPeriod: Object
  },
  data() {
    return {
      errorMessage: '',
      isActiveCalendarModal: false,
      isError: false,
      params: {
        from: dayjs(this.displayPeriod.from).format(),
        to: dayjs(this.displayPeriod.to).format(),
        // カレンダーで選択できる日付範囲: 1年前 ~ 現在時間
        minDate: dayjs(this.displayPeriod.from).subtract(10, 'year').format(),
        maxDate: dayjs().format(),
      },
      metrics: {
        total_cv: '-',
        unique_cv: '-',
        optin_user_cv: '-',
        optout_user_cv: '-',
        total_cv_diff: '-',
        unique_cv_diff: '-',
        optin_user_cv_diff: '-',
        optout_user_cv_diff: '-',
      },
      conversions: [],
      paginationInfo: null,
      updateGraph: null,
      isShowDisplayNumberPerPage: false,
      perPage: 10,
      page: 1,
      sortTargets: {
        conversion_value: 1,
        total_cv: 0,
        unique_cv: 0,
        optin_user_cv: 0,
        optout_user_cv: 0
      },
      isLoding: {
        metrics: true,
        graph: true,
        conversions: true,
      }
    }
  },
  computed: {
    formattedFrom: function () {
      return this.formatDate(this.params.from);
    },
    formattedTo: function () {
      return this.formatDate(this.params.to);
    },
  },
  mounted: function () {
    const period = this.displayPeriod;
    import('../../funcs/pages/conversion').then(module => {
      this.updateGraph = module.Conversion();
      this.updateGraph(period, null, () => { this.isLoding.graph = false; });
    });
    this.getMetrics(period);
    this.getConversions(period);
  },
  methods: {
    formatDate: function (dt) {
      return dayjs(dt).format('YYYY/MM/DD');
    },
    changePeriod: function (_date) {
      const period = { from: this.formattedFrom, to: this.formattedTo };
      this.updateGraph(period, null, () => { this.isLoding.graph = false; });
    },
    getNextUrl: function (item) {
      const period = this.params;
      const from = dayjs(period.from).format('YYYY-MM-DD');
      const to = dayjs(period.to).format('YYYY-MM-DD');
      return `/coins-admin/conversion/${encodeURIComponent(item.conversion_value)}/${from}/${to}`;
    },
    onPeriodClick: function () {
      this.isActiveCalendarModal = true;
      this.$refs.refCalendarModal.resetParams(this.params);
    },

    getMetrics: function (period) {
      const url = '/api/conversion/metrics';
      const params = {
        from: dayjs(period.from).format('YYYY-MM-DD'),
        to: dayjs(period.to).format('YYYY-MM-DD'),
      };
      this.isLoding.metrics = true;
      axios.get(url, { params: params })
        .then((response) => {
          const data = response.data;
          this.metrics = data.items;
          this.isLoding.metrics = false;
        })
        .catch((error) => {
          this.isError = true;
          this.errorMessage = error.response.data.message;
        });
    },

    getConversions: function (period) {
      const url = '/api/conversion/summary-group';
      let sortTarget = null;
      let order = null;
      for (let workTarget in this.sortTargets) {
        if(this.sortTargets[workTarget] != 0){
          sortTarget = workTarget;
          order = this.sortTargets[workTarget];
          break;
        }
      }
      const params = {
        from: dayjs(period.from).format('YYYY-MM-DD'),
        to: dayjs(period.to).format('YYYY-MM-DD'),
        sort: sortTarget,
        order: order,
        page: this.page,
        per_page: this.perPage,
      };
      this.isLoding.conversions = true;
      axios.get(url, { params: params })
        .then((response) => {
          this.isLoding.conversions = false;
          const data = response.data;
          this.conversions = data.items.data;
          this.paginationInfo = data.items;
          this.isShowDisplayNumberPerPage = (data.items.per_page < data.items.total) ? true : false;
        })
        .catch((error) => {
          this.isError = true;
          this.errorMessage = error.response.data.message;
        });
    },

    onSortButtonClick: function(target) {

      if(!this.sortTargets[target] || (this.sortTargets[target] == -1)){
        this.sortTargets[target] = 1;
      } else {
        this.sortTargets[target] = -1;
      }

      for (let workTarget in this.sortTargets) {
        if(workTarget != target){
          this.sortTargets[workTarget] = 0;
        }
      }
      this.getConversions(this.params);
    },

    // 表示件数変更
    onPerPageChanged: function() {

    },

    onPageClick: function(clickPage) {
      this.page = clickPage;
      this.getConversions(this.params);
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: カレンダーモーダルを閉じる処理
    onCloseCalendarModal: function () {
      this.isActiveCalendarModal = false
      // this.errorMessage = ''
    },
    // クリック: カレンダーモーダルを閉じる処理
    onChangeCalendarModal: function () {
      this.isActiveCalendarModal = false
      // this.errorMessage = ''
    },
    // クリック: カレンダーモーダルを閉じる処理
    onCancelCalendarModal: function () {
      this.isActiveCalendarModal = false
      // this.errorMessage = ''
    },
    // クリック: カレンダーモーダルを閉じる処理
    onEnterCalendarModal: function (from, to) {
      // 操作用モーダルのボタンローダーを表示
      this.isActiveCalendarModal = false
      this.params = {
        from: dayjs(from).format('YYYY-MM-DD'),
        to: dayjs(to).format('YYYY-MM-DD')
      }
      this.updateGraph(this.params, null, () => { this.isLoding.graph = false; });
      this.getMetrics(this.params);
      this.getConversions(this.params);
    },
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function () {
      this.isError = false
      this.errorMessage = ''
    },
  }
}
</script>
